import {
  Button,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  useDataProvider,
  useGetList,
  useNotify,
  useRefresh,
} from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import { studentRequests } from "api/studentApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { useFormContext, useWatch } from "react-hook-form";

const StatusFields = ({ currentStatus }) => {
  const selectedStatusId = useWatch({ name: "statusId" }) || currentStatus;
  const { setValue } = useFormContext();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="statusId"
          reference={studentRequests.getEducationStatusesSelect()}
        >
          <SelectInput
            label="Статус"
            optionText="name"
            defaultValue={currentStatus}
            validate={required()}
            fullWidth
            onChange={() => {
              setValue("reasonId", null);
              setValue("orderDate", null);
              setValue("orderNumber", null);
            }}
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          key={selectedStatusId}
          source="reasonId"
          reference={studentRequests.getEducationStatusReasonsSelect(selectedStatusId)}
        >
          <SelectInput
            optionText="name"
            label="Основание за"
            optionValue="id"
            validate={required("Задължително")}
            fullWidth
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <CustomDateInput
          label="Дата на заповед"
          source="orderDate"
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="orderNumber"
          label="Номер на заповед"
        />
      </Grid>
    </Grid>
  );
};

const ChangeStatusModal = ({ record, fetchHistory }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const { data: statusData } = useGetList(studentRequests.getEducationStatusesSelect(), {});

  const currentStatus = statusData?.find(x => x.name === record?.educationStatus).id;

  const handleSubmit = async data => {
    const payload = {
      statusId: data.statusId,
      reasonId: data.reasonId,
      orderDate: data.orderDate,
      orderNumber: data.orderNumber,
    };
    await dataProvider.customRequest(studentRequests.updateStudentStatus(record.id), payload, "PUT");
    refresh();
    fetchHistory();
    notify(`Успешна редакция на статус`, { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Редакция на статус"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          size="small"
          label="Редакция на статус"
        />
      }
    >
      <StatusFields currentStatus={currentStatus} />
    </FormModal>
  );
};

export default ChangeStatusModal;
